import React from 'react'
import Fragment from '../common/fragment'

function FragmentDE(props) {
  return (
    <Fragment pos="eeee" {...props}>
      <p>
      Tezcatlipoca es un espejo humeante y está vinculado con el aire. Pero, por otro
lado, lo que nos llevó al muñeco autómata es la imagen de un mancebo que era
elegido, en tiempo de Tenochtitlan, para convertirse en Tezcatlipoca. Tezcatlipoca
es un espejo humeante, aire. Muñeco autómata/imagen de un mancebo/elegido en
tiempo de Tenochtitlan para convertirse en Tezcatlipoca. ¿Cómo se convierte un
dios en sí mismo si lo que le entregamos es el cuerpo del otro? Dislexia y miopía,
artritis y cefalea.
      </p>
    </Fragment>
  )
}


export default FragmentDE
